(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
})((function () { 'use strict';

  /**
   * This is the default functionality for elements with ".page-nav.js", which will
   * set the active .menu-item using the href (e.g. anchor/hash) of the .menu-link.
   *
   * Specific implimentations on how the panels are switched vary, but essentially
   * follow the below construct.
   *
   * @see _front.page-nav-materials.js
   * @see _front.page-nav-wpbakery.js
   */
  (function(){
    var pageNavDropdownElem = document.querySelector('.page-nav .page-nav__dropdown');
    if (pageNavDropdownElem) pageNavDropdownElem.addEventListener('change', function(e){
      e.preventDefault();
      location.href = this.value;
    });
    // find first page-nav element (others are ignored)
    var pageNavElem = document.querySelector('.page-nav.js');
    if (!pageNavElem) return;

    var menuElem = pageNavElem.querySelector('.menu');
    var firstHash = menuElem.querySelector('.menu-link').getAttribute('href');
    function setActiveMenuItem(hash) {
      hash = hash ? hash : firstHash;
      hash = '#' + hash.replace('#', '');
      var menuItemElem = menuElem.querySelector('[href="' + hash + '"]').closest('.menu-item');
      menuElem.querySelectorAll('.menu-item').forEach(function(elem){
        elem.className = elem.className.replace(' active', '');
      });
      menuItemElem.className += ' active';
    }

    // listen for hash changes
    window.addEventListener('hashchange', function(e){
      setActiveMenuItem(window.location.hash);
    }, false);

    // onload hash check
    if (window.location.hash) {
      setActiveMenuItem(window.location.hash);
      ready(function(){
        // @see https://stackoverflow.com/a/13736194
        // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
        pageNavElem.scrollIntoView({behavior: 'smooth'});
      });
    }
    // set first menu item hash active
    else setActiveMenuItem(firstHash);
  })();

}));
